module.exports = __webpack_public_path__ + "static/media/NWSlogo.400b71f1.jpeg";